<template>
  <main>
    <div v-if="loaded">
      <AppSelect :jobs="jobData" @changejob="selJob = $event" />
      <AppGraph :jobs="jobData" :selection="selJob" />
    </div>
  </main>
</template>

<script>
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';
import * as d3 from "d3";
import AppSelect from "./Select.vue";
import AppGraph from "./Graph.vue";
export default {
  data: function() {
    return {
      jobData: [],
      selJob: ""
    };
  },
  props: {
    loaded: {
      type: Boolean
    }
  },
  components: {
    AppSelect: AppSelect,
    AppGraph: AppGraph
  },
  beforeMount() {
    d3.csv("./data.csv").then(data => {
      this.jobData = data;
      this.$emit("load", true);
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Main.vue